import { useNavigate } from 'react-router-dom';
import { Wrench, PlusCircle, CalendarDays, ClipboardList } from 'lucide-react';
import { useAppStore } from '../../store/useAppStore';

const navItems = [
  {
    icon: <Wrench size={22} />,
    emoji: '🔧',
    label: 'Rent a Tool',
    path: '/browse',
    color: 'bg-blue-500',
    hoverColor: 'hover:bg-blue-600',
    ringColor: 'ring-blue-200',
    requiresAuth: false,
  },
  {
    icon: <PlusCircle size={22} />,
    emoji: '➕',
    label: 'List a Tool',
    path: '/list-tool',
    color: 'bg-garden-500',
    hoverColor: 'hover:bg-garden-600',
    ringColor: 'ring-garden-200',
    requiresAuth: true,
  },
  {
    icon: <CalendarDays size={22} />,
    emoji: '📅',
    label: 'My Rentals',
    path: '/my-rentals',
    color: 'bg-purple-500',
    hoverColor: 'hover:bg-purple-600',
    ringColor: 'ring-purple-200',
    requiresAuth: true,
  },
  {
    icon: <ClipboardList size={22} />,
    emoji: '✅',
    label: 'My Listings',
    path: '/my-listings',
    color: 'bg-teal-500',
    hoverColor: 'hover:bg-teal-600',
    ringColor: 'ring-teal-200',
    requiresAuth: true,
  },
] as const;

export function NavIcons() {
  const navigate = useNavigate();
  const { user, openAuthModal } = useAppStore();

  const handleClick = (item: (typeof navItems)[number]) => {
    if (item.requiresAuth && !user) {
      openAuthModal('register', item.path);
    } else {
      navigate(item.path);
    }
  };

  return (
    <div className="w-full max-w-sm mx-auto">
      <div className="grid grid-cols-4 gap-3">
        {navItems.map((item) => (
          <button
            key={item.label}
            onClick={() => handleClick(item)}
            className="nav-icon group"
            aria-label={item.label}
          >
            <div
              className={`nav-icon-bubble ${item.color} ${item.hoverColor} text-white
                          group-active:scale-90 ring-0 group-hover:ring-4 ${item.ringColor}
                          transition-all duration-200`}
            >
              <span role="img" aria-hidden className="text-xl leading-none">
                {item.emoji}
              </span>
            </div>
            <span className="text-[13px] font-medium text-silver-700 group-hover:text-silver-800
                             text-center leading-tight transition-colors">
              {item.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
